import { render, staticRenderFns } from "./Strech.vue?vue&type=template&id=45c1417d&scoped=true"
import script from "./Strech.vue?vue&type=script&lang=js"
export * from "./Strech.vue?vue&type=script&lang=js"
import style0 from "./Strech.vue?vue&type=style&index=0&id=45c1417d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c1417d",
  null
  
)

export default component.exports